import { Component, forwardRef, Input, OnChanges } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { sectionAnimations } from '@platform/helpers/animations.helper';
import { noop } from 'lodash';

import { EMMAFormElementComponent } from './emma-form-element.component';

const CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => EMMASwitchOrSliderComponent),
  multi: true,
};
const VALIDATOR: any = {
  provide: NG_VALIDATORS,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => EMMASwitchOrSliderComponent),
  multi: true,
};

@Component({
    selector: 'emma-switch-or-slider',
    templateUrl: './emma-switch-or-slider.component.html',
    providers: [CONTROL_VALUE_ACCESSOR, VALIDATOR],
    animations: [...sectionAnimations],
    standalone: false
})
export class EMMASwitchOrSliderComponent
  extends EMMAFormElementComponent
  implements OnChanges, ControlValueAccessor, Validator
{
  @Input() min = 1;
  @Input() max = 10;
  @Input() tickStep = 1;
  @Input() getLegend?: (priority: number) => string;
  @Input() slideLabel = $localize`Valor`;

  @Input() activeLabel = '';
  @Input() valueLabel = '';
  @Input() defaultValue?: number | string;
  @Input() offValue?: number | string;
  @Input() get value(): number | string | undefined {
    return this.innerValue;
  }
  set value(value: number | string | undefined) {
    // on switch change effect
    if (value !== this.innerValue) {
      this.innerValue = value;
      this.onChangeCallback(value);
      this.$change.emit(value);
      this.updateActive();
    }
  }
  private innerValue?: number | string;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: number | string | undefined) => void = noop;

  active = false;

  override ngOnChanges() {
    this.updateActive();
  }

  onBlur() {
    this.onTouchedCallback();
    this.$blur.emit();
    this.updateActive();
  }

  onChangeSwitch(active: boolean) {
    if (!active) {
      this.value = this.offValue;
    } else {
      // inicializar al activar el switch
      this.value = this.defaultValue;
    }
    this.onBlur();
  }

  updateActive() {
    this.active = this.innerValue !== this.offValue;
  }

  // From ControlValueAccessor interface
  writeValue(value: number | string | undefined) {
    if (value !== this.innerValue) {
      this.innerValue = value;
      this.updateActive();
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  // From Validator interface
  override validate: ValidatorFn = (control: AbstractControl) => {
    const validators: ValidatorFn[] = [];
    if (this.required) {
      validators.push(Validators.required);
    }
    if (this.validateFn) {
      validators.push(this.validateFn);
    }
    if (validators.length) {
      const validator = Validators.compose(validators);
      return validator ? validator(control) : null;
    }
    return null;
  };
}
